/**
 * Copyright © Ircam Amplify 2024-2026
 */
import ToggleSwitch from '@/components/ToggleSwitch'
import { baseURL } from '@/config/env'
import { getUserState, useSelector } from '@/store'
import { apiRequest } from '@amplify3/duplo-back-end'
import { Field, Form, Formik } from 'formik'

export const Settings = () => {
  const { companyConsumption } = useSelector(getUserState)

  const submit = async (values: any) => {
    await apiRequest({
      method: 'post',
      baseURL,
      url: '/user/alerts',
      data: values,
    })
  }

  return (
    Boolean(companyConsumption) && (
      <div className="w-4/6 md:w-full">
        <h3 className="mb-5">Alerts</h3>
        <Formik
          initialValues={{
            percentage: Number(companyConsumption?.alert ?? 0),
            enabled: Number(companyConsumption?.alert ?? -1) > -1,
          }}
          enableReinitialize
          onSubmit={submit}
        >
          {({ values, isSubmitting, touched, handleChange, handleBlur }) => (
            <Form>
              <div className="w-full border rounded-xl my-8 px-6 py-6 border-gray-400 flex ">
                <div className="flex w-5/6 justify-center items-end">
                  <div className="w-4/6 flex-auto">
                    <div className="w-full flex items-end">
                      <div className="w-5/6">
                        <label
                          htmlFor="percentage"
                          className="block mb-2 text-baseline text-primary-900"
                        >
                          Set the maximum amount of credits you want to use and
                          be alerted when you have reached it. You have consumed{' '}
                          <b>
                            0 &nbsp;/&nbsp;
                            {Number(
                              companyConsumption?.current_plan ?? 0
                            )}
                          </b>{' '}
                          credits
                        </label>
                        <Field
                          id="percentage"
                          name="percentage"
                          type="range"
                          className="transparent h-2 w-full cursor-pointer appearance-none border-transparent bg-primary-300 accent-primary-800 rounded"
                        />
                      </div>
                      <div className="w-1/6 md:w-2/6 text-center">
                        {values.percentage}% (currently&nbsp;
                        {values.percentage *
                          (Number(
                            companyConsumption?.current_plan ?? 0
                          ) /
                            100)}
                        &nbsp;credits)
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-1/6 flex items-end">
                  <Field
                    as={ToggleSwitch}
                    id="enabled"
                    disabledLabel="Disabled"
                    enabledLabel="Enabled"
                    name="enabled"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.enabled}
                  />
                </div>
              </div>
              <div className="w-full">
                <div className="w-52">
                  <button
                    type="submit"
                    className="w-full button button-large button-dark py-2 px-4"
                    disabled={isSubmitting || !touched}
                  >
                    <div className="button button-label">Save</div>
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  )
}
